
// countdown.js.liquid

  let endDate = new Date("February 27, 2026 23:59 GMT+0100").getTime();
  const intervall = 1000 * 60 * 60 * 0;
  const now = new Date().getTime();

  const dates = [];

  if (intervall > 0){
    while (endDate > now) {
      dates.push(new Date(endDate));
      endDate -= intervall;
    }
  } else {
      dates.push(new Date(endDate));
  }

  dates.reverse();

  function getNextDate() {
    let now = new Date().getTime();
    for (let date of dates) {
      if (date > now) {
        return date;
      }
    }
    return null;
  }

  const intervallId = setInterval(function () {
    const countdownAnnouncement = document.querySelector("#countdown_announcement");
    const countdownProduct = document.querySelector("#countdown_product");
    let countDown = getNextDate();
    if (countDown === null) {
      countdownAnnouncement.innerHTML = "";
      document.getElementById("countdown_product").innerHTML = "";
      document.getElementById("countdown_product_wrapper").className = " no-js"; 
      clearInterval(intervallId);
      return;
    }

    const distanceNow = countDown - new Date().getTime();

    var days = Math.floor(distanceNow / (1000 * 60 * 60 * 24));
    var hours = Math.floor((distanceNow % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var minutes = Math.floor((distanceNow % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((distanceNow % (1000 * 60)) / 1000);
    
    
      countdownAnnouncement.innerHTML = `<span class="countdown_days"><span class="countdown_text">${days}<span class="text_count">` + " T " + `</span></span></span>` + `<span class="countdown_text">${hours}<span class="text_count">` + " Std "
      + `</span></span><span class="countdown_text">${minutes}<span class="text_count">` + " Min " + `</span></span><span class="countdown_text">${seconds}<span class="text_count">` + " S " + `</span></span>`;
    

    if (countdownProduct){
      
         countdownProduct.innerHTML = `<span style="display:flex"><span class="countdown_text_promo countdown_days"><span><span class="countdown_text_promo_date countdown_days">${days}<span class="countdown_text_promo_description countdown_days">  TAGE  </span></span></span> </span> <span class="countdown_days number_separator_count" style=""> : </span> <span class="countdown_text_promo"><span><span class="countdown_text_promo_date text_when_day_disable">${hours}<span class="countdown_text_promo_description"> STUNDEN </span></span></span> 
       </span><span class="number_separator_count" style=""> : </span><span class="countdown_text_promo"><span><span class="countdown_text_promo_date text_when_day_disable">${minutes}<span class="countdown_text_promo_description"> MINUTEN</span></span></span></span><span class="number_separator_count" style=""> : </span><span class="countdown_text_promo"><span><span class="countdown_text_promo_date text_when_day_disable">${seconds}<span class="countdown_text_promo_description">SEKUNDEN</span></span><span></span></span> </span></span>`;
      
    }

  }, 1000);
